import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import {
  ProjectResponseModel,
  bidSubmissionModel,
} from "../../models/ProjectResponseModel";
import ProjectResponseService from "../../services/ProjectResponseService";
import ProjectResponseSlice from "../slices/ProjectResponseSlice";
import { RootState } from "../store";

export const ProjectResponseActions = ProjectResponseSlice.actions;
export const fetchAllProjectsWithStatus = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch, getState) => {
    dispatch(ProjectResponseActions.setIsFetching(true));
    const response: ProjectResponseModel[] =
      await ProjectResponseService.getAllProjectsWithStatus();
    dispatch(ProjectResponseActions.setAllProjectsWithStatus(response));
    dispatch(ProjectResponseActions.setIsFetching(false));
  };
};
export const fetchProjectsWithStatusForUserId = (
  userId: number,
  roleId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    dispatch(ProjectResponseActions.setIsFetching(true));
    const response: ProjectResponseModel[] =
      await ProjectResponseService.getProjectsWithStatusForUserId(
        userId,
        roleId
      );
    dispatch(ProjectResponseActions.setProjectsWithStatusForUserId(response));
    dispatch(ProjectResponseActions.setIsFetching(false));
  };
};

export const setProjectBidSubmissionData = (
  data: bidSubmissionModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectResponseActions.setProjectBidSubmissionData(data));
  };
};

export const setProjectResponseIsBidDropped = (data: {
  id: number;
  status: boolean;
}): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectResponseActions.setIsBidDropped(data));
  };
};

export const setProjectResponseBidPriority = (data: {
  id: number;
  priority: string;
}): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectResponseActions.setBidPriority(data));
  };
};
